import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { MatDividerModule } from '@angular/material/divider';
import { RolesComponent } from './roles.component';
import { RolesRoutingModule } from './roles-routing.modules';
import { ToolbarModule } from 'src/app/layout/toolbar/toolbar.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    RolesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    RolesRoutingModule,
    ToolbarModule,
    MatProgressSpinnerModule,
    MatMenuModule
  ]
})
export class RolesModule { }
